import React, { Component } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Route, Switch, Link} from 'react-router-dom';
import Home from './Home';
import Employee from './Employee';
import MonthlyRegistrationContainer from './MonthlyRegistration/MonthlyRegistrationContainer';

export default class App extends Component {
  render() {
    return (
      <div>
        <Router>
          <Switch>
            <Route path="/" exact strict component={() => <MonthlyRegistrationContainer />}/>
            <Route path="/oldUi" exact strict component={() => <Home />}/>
            <Route path="/employee" exact strict component={() => <Employee />}/>
            <Route path="/vip" exact strict component={() => <Employee vip={true}/>}/>
            <Route path="/vendor" exact strict component={() => <Employee vendor={true}/>}/>
            <Route path="/fiu" exact strict component={() => <Employee fiu={true}/>}/>
          </Switch>
        </Router>
      </div>
    )
  }
}  